/**
 * Ported from the Slate-era webpack bundle (src/scripts/sections/product-tabs.js).
 */
(function () {
function changeTabs(e) {
  e.preventDefault();
  const target = e.target;
  const tablist = target.closest('[role="tablist"]');
  const container = target.closest('[data-tab-container]');
  const tabpanels = container.querySelector('.tab-content');
  const activeClass = 'active';

  // Remove all current selected tabs
  tablist.querySelectorAll('[aria-selected="true"]').forEach((tab) => {
    tab.setAttribute('aria-selected', false);
    tab.classList.remove(activeClass);
  });

  // Set this tab as selected
  target.setAttribute('aria-selected', true);
  target.classList.add(activeClass);

  // Hide all tab panels
  for (let i = 0; i < tabpanels.children.length; i++) {
    tabpanels.children[i].setAttribute('hidden', true);
    tabpanels.children[i].classList.remove(activeClass);
  }

  // Show the selected panel
  const activeTab = container.parentNode.querySelector(
    `#${target.getAttribute('aria-controls')}`
  );
  activeTab.removeAttribute('hidden');
  activeTab.classList.add(activeClass);

  const selectTabEvent = new CustomEvent('performance.selectContent', {
    detail: {
      content_type: 'Product detail tab',
      content_id: target.innerText
    }
  });
  window.dispatchEvent(selectTabEvent);
}

document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('[role="tab"]');
  const tabList = document.querySelector('[role="tablist"]');

  // Add a click event handler to each tab
  tabs.forEach((tab) => {
    tab.addEventListener('click', changeTabs);
  });
});

})();
